
















import { Component, Vue } from 'vue-property-decorator'

const TABS = ['standard', 'negotiated', 'programs']

@Component({
  name: 'SorewardsSettings',
  components: {
    StandardRates: () => import('@/views/sorewards/settings/standard-rates.vue'),
    NegotiatedRates: () => import('@/views/sorewards/settings/negotiated-rates.vue'),
    ProgramMapping: () => import('@/views/sorewards/settings/program-mapping.vue')
  }
})
export default class extends Vue {
  private activeTab = 'standard'

  created() {
    const tab = this.$route.query.tab as string
    if (TABS.includes(tab)) {
      this.activeTab = tab
    }
  }

  private onTabChange() {
    this.$router.replace({ query: { tab: this.activeTab } }).catch(err => err)
  }
}
